import {
  SET_STATION,
  FETCH_PRESENTATION_STATION_REQUEST,
  POST_DEVICE_COMMAND_REQUEST,
  FETCH_STATIONS_REQUEST,
  UPDATE_STATION_REQUEST,
  DELETE_STATION_REQUEST,
  POST_REBOOT_REQUEST,
  POST_SYNC_REQUEST
} from './constants'

export function setStationState(newStationState) {
  return {type: SET_STATION, newStationState}
}

export function fetchStationPresentation() {
  return {type: FETCH_PRESENTATION_STATION_REQUEST}
}

export function postDeviceCommand(newCommandState) {
  return {type: POST_DEVICE_COMMAND_REQUEST, newCommandState}
}

export function fetchStations(offset, limit) {
  return {type: FETCH_STATIONS_REQUEST, offset, limit}
}

export function updateStation(updateStationState) {
  return {type: UPDATE_STATION_REQUEST, updateStationState}
}

export function deleteStation(deleteStationState) {
  return {type: DELETE_STATION_REQUEST, deleteStationState}
}

export function postReboot(newRebootState) {
  return {type: POST_REBOOT_REQUEST, newRebootState}
}

export function postSyncReq(newSyncReqState) {
  return {type: POST_SYNC_REQUEST, newSyncReqState}
}



// WEBPACK FOOTER //
// ./src/actions/station.js